import React from 'react'
import "./Orange_btn.css"
import { Button } from 'react-bootstrap'

function Orange_btn({ btnText, onClick }) {
    return (
        <>
            <section className='Orange_btn_holder'>

                <Button className="Orange_btn" onClick={onClick}>{btnText}  </Button>

            </section>
        </>
    )
}

export default Orange_btn